import { createSlice } from '@reduxjs/toolkit';

import * as reducers from 'store/reducers/authReducer';

const initialState = {
  isAuthenticated: false,
  user: null,
  clientDedupID: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers,
});

export const { login, logout, setUser, setStoreClientDedupID } = authSlice.actions;
export default authSlice.reducer;
